import { defineComponent as n, computed as o, openBlock as i, createElementBlock as a, createElementVNode as e, toDisplayString as d, createCommentVNode as h, normalizeStyle as _ } from "vue";
const f = ["viewBox"], m = /* @__PURE__ */ e("mask", { id: "d9f716ba-a763-4646-96f8-9bc4774a6d9d" }, [
  /* @__PURE__ */ e("circle", {
    cx: "256",
    cy: "256",
    r: "256",
    fill: "#fff"
  })
], -1), u = { mask: "url(#d9f716ba-a763-4646-96f8-9bc4774a6d9d)" }, v = { key: 0 }, k = /* @__PURE__ */ e("path", {
  fill: "#eee",
  d: "M0 0h256l52 259.2L256 512H0z"
}, null, -1), p = /* @__PURE__ */ e("path", {
  fill: "#d80027",
  d: "M256 0h256v512H256z"
}, null, -1), g = /* @__PURE__ */ e("path", {
  fill: "#acabb1",
  d: "M178 100.2V66.8h-33.3v33.4h-33.4v33.4h33.4V167h33.4v-33.4h33.4v-33.4z"
}, null, -1), x = { fill: "none" }, w = ["r"], z = /* @__PURE__ */ n({
  __name: "mt",
  props: {
    flagName: {},
    strokeColor: { default: "#000" },
    strokeWidth: { default: 0 }
  },
  setup(c) {
    const t = c, l = o(() => 512 + 2 * t.strokeWidth), s = o(() => -t.strokeWidth), r = o(() => 256 + t.strokeWidth / 2);
    return (b, y) => (i(), a("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      class: "svg-circle-flags",
      viewBox: `${s.value} ${s.value} ${l.value} ${l.value}`
    }, [
      m,
      e("g", u, [
        t.flagName ? (i(), a("title", v, d(t.flagName), 1)) : h("", !0),
        k,
        p,
        g
      ]),
      e("g", x, [
        e("circle", {
          cx: "256",
          cy: "256",
          r: r.value,
          fill: "none",
          style: _({ stroke: t.strokeColor, strokeWidth: t.strokeWidth })
        }, null, 12, w)
      ])
    ], 8, f));
  }
});
export {
  z as default
};
//# sourceMappingURL=mt-ccb601ac.js.map
